/**
 * This maps the unicode emoji to emoji_id which is the index of the hex in the array.
 *
 * You must not change the order of the array.
 *
 * You can only append to the array.
 *
 * You should never delete from the array.
 */
const emojiMap = [
  '', // start from 1
  '1f4af', // 💯 hundred points
  '1f522', // 🔢 input numbers
  '1f441-200d-1f5e8', // 👁️‍🗨️ eye in speech bubble
  '1f498', // 💘 heart with arrow
  '2764-fe0f', // ❤️ red heart
  '1f493', // 💓 beating heart
  '1f494', // 💔 broken heart
  '1f495', // 💕 two hearts
  '1f496', // 💖 sparkling heart
  '1f497', // 💗 growing heart
  '1f499', // 💙 blue heart
  '1f49a', // 💚 green heart
  '1f49b', // 💛 yellow heart
  '1f49c', // 💜 purple heart
  '1f5a4', // 🖤 black heart
  '1f49d', // 💝 heart with ribbon
  '1f49e', // 💞 revolving hearts
  '1f49f', // 💟 heart decoration
  '2763-fe0f', // ❣️ heart exclamation
  '1f4a2', // 💢 anger symbol
  '1f4a5', // 💥 collision
  '1f4ab', // 💫 dizzy
  '1f4ac', // 💬 speech balloon
  '1f5e8-fe0f', // 🗨️ left speech bubble
  '1f5ef-fe0f', // 🗯️ right anger bubble
  '1f4ad', // 💭 thought balloon
  '1f4ae', // 💮 white flower
  '1f310', // 🌐 globe with meridians
  '2668-fe0f', // ♨️ hot springs
  '1f6d1', // 🛑 stop sign
  '1f55b', // 🕛️ twelve o’clock
  '1f567', // 🕧️ twelve-thirty
  '1f550', // 🕐️ one o’clock
  '1f55c', // 🕜️ one-thirty
  '1f551', // 🕑️ two o’clock
  '1f55d', // 🕝️ two-thirty
  '1f552', // 🕒️ three o’clock
  '1f55e', // 🕞️ three-thirty
  '1f553', // 🕓️ four o’clock
  '1f55f', // 🕟️ four-thirty
  '1f554', // 🕔️ five o’clock
  '1f560', // 🕠️ five-thirty
  '1f555', // 🕕️ six o’clock
  '1f561', // 🕡️ six-thirty
  '1f556', // 🕖️ seven o’clock
  '1f562', // 🕢️ seven-thirty
  '1f557', // 🕗️ eight o’clock
  '1f563', // 🕣️ eight-thirty
  '1f558', // 🕘️ nine o’clock
  '1f564', // 🕤️ nine-thirty
  '1f559', // 🕙️ ten o’clock
  '1f565', // 🕥️ ten-thirty
  '1f55a', // 🕚️ eleven o’clock
  '1f566', // 🕦️ eleven-thirty
  '1f300', // 🌀 cyclone
  '2660-fe0f', // ♠️ spade suit
  '2665-fe0f', // ♥️ heart suit
  '2666-fe0f', // ♦️ diamond suit
  '2663-fe0f', // ♣️ club suit
  '1f0cf', // 🃏 joker
  '1f004-fe0f', // 🀄️ mahjong red dragon
  '1f3b4', // 🎴 flower playing cards
  '1f507', // 🔇 muted speaker
  '1f508', // 🔈️ speaker low volume
  '1f509', // 🔉 speaker medium volume
  '1f50a', // 🔊 speaker high volume
  '1f4e2', // 📢 loudspeaker
  '1f4e3', // 📣 megaphone
  '1f514', // 🔔 bell
  '1f515', // 🔕 bell with slash
  '1f3b5', // 🎵 musical note
  '1f3b6', // 🎶 musical notes
  '1f4b9', // 💹 chart increasing with yen
  '1f4b1', // 💱 currency exchange
  '1f4b2', // 💲 heavy dollar sign
  '1f3e7', // 🏧 ATM sign
  '1f6ae', // 🚮 litter in bin sign
  '1f6b0', // 🚰 potable water
  '267f-fe0f', // ♿️ wheelchair symbol
  '1f6b9', // 🚹️ men’s room
  '1f6ba', // 🚺️ women’s room
  '1f6bb', // 🚻 restroom
  '1f6bc', // 🚼️ baby symbol
  '1f6be', // 🚾 water closet
  '1f6c2', // 🛂 passport control
  '1f6c3', // 🛃 customs
  '1f6c4', // 🛄 baggage claim
  '1f6c5', // 🛅 left luggage
  '26a0-fe0f', // ⚠️ warning
  '1f6b8', // 🚸 children crossing
  '26d4-fe0f', // ⛔️ no entry
  '1f6ab', // 🚫 prohibited
  '1f6b3', // 🚳 no bicycles
  '1f6ad', // 🚭️ no smoking
  '1f6af', // 🚯 no littering
  '1f6b1', // 🚱 non-potable water
  '1f6b7', // 🚷 no pedestrians
  '1f4f5', // 📵 no mobile phones
  '1f51e', // 🔞 no one under eighteen
  '2622-fe0f', // ☢️ radioactive
  '2623-fe0f', // ☣️ biohazard
  '2b06-fe0f', // ⬆️ up arrow
  '2197-fe0f', // ↗️ up-right arrow
  '27a1-fe0f', // ➡️ right arrow
  '2198-fe0f', // ↘️ down-right arrow
  '2b07-fe0f', // ⬇️ down arrow
  '2199-fe0f', // ↙️ down-left arrow
  '2b05-fe0f', // ⬅️ left arrow
  '2196-fe0f', // ↖️ up-left arrow
  '2195-fe0f', // ↕️ up-down arrow
  '2194-fe0f', // ↔️ left-right arrow
  '21a9-fe0f', // ↩️ right arrow curving left
  '21aa-fe0f', // ↪️ left arrow curving right
  '2934-fe0f', // ⤴️ right arrow curving up
  '2935-fe0f', // ⤵️ right arrow curving down
  '1f503', // 🔃 clockwise vertical arrows
  '1f504', // 🔄 counterclockwise arrows button
  '1f519', // 🔙 BACK arrow
  '1f51a', // 🔚 END arrow
  '1f51b', // 🔛 ON! arrow
  '1f51c', // 🔜 SOON arrow
  '1f51d', // 🔝 TOP arrow
  '1f6d0', // 🛐 place of worship
  '269b-fe0f', // ⚛️ atom symbol
  '1f549-fe0f', // 🕉️ om
  '2721-fe0f', // ✡️ star of David
  '2638-fe0f', // ☸️ wheel of dharma
  '262f-fe0f', // ☯️ yin yang
  '271d-fe0f', // ✝️ latin cross
  '2626-fe0f', // ☦️ orthodox cross
  '262a-fe0f', // ☪️ star and crescent
  '262e-fe0f', // ☮️ peace symbol
  '1f54e', // 🕎 menorah
  '1f52f', // 🔯 dotted six-pointed star
  '2648-fe0f', // ♈️ Aries
  '2649-fe0f', // ♉️ Taurus
  '264a-fe0f', // ♊️ Gemini
  '264b-fe0f', // ♋️ Cancer
  '264c-fe0f', // ♌️ Leo
  '264d-fe0f', // ♍️ Virgo
  '264e-fe0f', // ♎️ Libra
  '264f-fe0f', // ♏️ Scorpio
  '2650-fe0f', // ♐️ Sagittarius
  '2651-fe0f', // ♑️ Capricorn
  '2652-fe0f', // ♒️ Aquarius
  '2653-fe0f', // ♓️ Pisces
  '26ce', // ⛎️ Ophiuchus
  '1f500', // 🔀 shuffle tracks button
  '1f501', // 🔁 repeat button
  '1f502', // 🔂 repeat single button
  '25b6-fe0f', // ▶️ play button
  '23e9', // ⏩️ fast-forward button
  '23ed-fe0f', // ⏭️ next track button
  '23ef-fe0f', // ⏯️ play or pause button
  '25c0-fe0f', // ◀️ reverse button
  '23ea', // ⏪️ fast reverse button
  '23ee-fe0f', // ⏮️ last track button
  '1f53c', // 🔼 upwards button
  '23eb', // ⏫️ fast up button
  '1f53d', // 🔽 downwards button
  '23ec', // ⏬️ fast down button
  '23f8-fe0f', // ⏸️ pause button
  '23f9-fe0f', // ⏹️ stop button
  '23fa-fe0f', // ⏺️ record button
  '23cf-fe0f', // ⏏️ eject button
  '1f3a6', // 🎦 cinema
  '1f505', // 🔅 dim button
  '1f506', // 🔆 bright button
  '1f4f6', // 📶 antenna bars
  '1f4f3', // 📳 vibration mode
  '1f4f4', // 📴 mobile phone off
  '267b-fe0f', // ♻️ recycling symbol
  '1f4db', // 📛 name badge
  '269c-fe0f', // ⚜️ fleur-de-lis
  '1f530', // 🔰 Japanese symbol for beginner
  '1f531', // 🔱 trident emblem
  '2b55-fe0f', // ⭕️ hollow red circle
  '2705', // ✅️ check mark button
  '2611-fe0f', // ☑️ check box with check
  '2714-fe0f', // ✔️ check mark
  '2716-fe0f', // ✖️ multiply
  '274c', // ❌️ cross mark
  '274e', // ❎️ cross mark button
  '2795', // ➕️ plus
  '2796', // ➖️ minus
  '2797', // ➗️ divide
  '27b0', // ➰️ curly loop
  '27bf', // ➿️ double curly loop
  '303d-fe0f', // 〽️ part alternation mark
  '2733-fe0f', // ✳️ eight-spoked asterisk
  '2734-fe0f', // ✴️ eight-pointed star
  '2747-fe0f', // ❇️ sparkle
  '203c-fe0f', // ‼️ double exclamation mark
  '2049-fe0f', // ⁉️ exclamation question mark
  '2753', // ❓️ red question mark
  '2754', // ❔️ white question mark
  '2755', // ❕️ white exclamation mark
  '2757-fe0f', // ❗️ red exclamation mark
  '3030-fe0f', // 〰️ wavy dash
  '00a9-fe0f', // ©️ copyright
  '00ae-fe0f', // ®️ registered
  '2122-fe0f', // ™️ trade mark
  '0023-fe0f-20e3', // #️⃣ keycap: #
  '002a-fe0f-20e3', // *️⃣ keycap: *
  '0030-fe0f-20e3', // 0️⃣ keycap: 0
  '0031-fe0f-20e3', // 1️⃣ keycap: 1
  '0032-fe0f-20e3', // 2️⃣ keycap: 2
  '0033-fe0f-20e3', // 3️⃣ keycap: 3
  '0034-fe0f-20e3', // 4️⃣ keycap: 4
  '0035-fe0f-20e3', // 5️⃣ keycap: 5
  '0036-fe0f-20e3', // 6️⃣ keycap: 6
  '0037-fe0f-20e3', // 7️⃣ keycap: 7
  '0038-fe0f-20e3', // 8️⃣ keycap: 8
  '0039-fe0f-20e3', // 9️⃣ keycap: 9
  '1f51f', // 🔟 keycap: 10
  '1f520', // 🔠 input latin uppercase
  '1f521', // 🔡 input latin lowercase
  '1f523', // 🔣 input symbols
  '1f524', // 🔤 input latin letters
  '1f170', // 🅰️ A button (blood type)
  '1f18e', // 🆎 AB button (blood type)
  '1f171', // 🅱️ B button (blood type)
  '1f191', // 🆑 CL button
  '1f192', // 🆒 COOL button
  '1f193', // 🆓 FREE button
  '2139-fe0f', // ℹ️ information
  '1f194', // 🆔 ID button
  '24c2-fe0f', // Ⓜ️ circled M
  '1f195', // 🆕 NEW button
  '1f196', // 🆖 NG button
  '1f17e', // 🅾️ O button (blood type)
  '1f197', // 🆗 OK button
  '1f17f-fe0f', // 🅿️ P button
  '1f198', // 🆘 SOS button
  '1f199', // 🆙 UP! button
  '1f19a', // 🆚 VS button
  '1f201', // 🈁 Japanese “here” button
  '1f202-fe0f', // 🈂️ Japanese “service charge” button
  '1f237-fe0f', // 🈷️ Japanese “monthly amount” button
  '1f236', // 🈶 Japanese “not free of charge” button
  '1f22f-fe0f', // 🈯️ Japanese “reserved” button
  '1f250', // 🉐 Japanese “bargain” button
  '1f239', // 🈹 Japanese “discount” button
  '1f21a-fe0f', // 🈚️ Japanese “free of charge” button
  '1f232', // 🈲 Japanese “prohibited” button
  '1f251', // 🉑 Japanese “acceptable” button
  '1f238', // 🈸 Japanese “application” button
  '1f234', // 🈴 Japanese “passing grade” button
  '1f233', // 🈳 Japanese “vacancy” button
  '3297-fe0f', // ㊗️ Japanese “congratulations” button
  '3299-fe0f', // ㊙️ Japanese “secret” button
  '1f23a', // 🈺 Japanese “open for business” button
  '1f235', // 🈵 Japanese “no vacancy” button
  '25aa-fe0f', // ▪️ black small square
  '25ab-fe0f', // ▫️ white small square
  '25fb-fe0f', // ◻️ white medium square
  '25fc-fe0f', // ◼️ black medium square
  '25fd-fe0f', // ◽️ white medium-small square
  '25fe-fe0f', // ◾️ black medium-small square
  '2b1b-fe0f', // ⬛️ black large square
  '2b1c-fe0f', // ⬜️ white large square
  '1f536', // 🔶 large orange diamond
  '1f537', // 🔷 large blue diamond
  '1f538', // 🔸 small orange diamond
  '1f539', // 🔹 small blue diamond
  '1f53a', // 🔺 red triangle pointed up
  '1f53b', // 🔻 red triangle pointed down
  '1f4a0', // 💠 diamond with a dot
  '1f518', // 🔘 radio button
  '1f532', // 🔲 black square button
  '1f533', // 🔳 white square button
  '26aa-fe0f', // ⚪️ white circle
  '26ab-fe0f', // ⚫️ black circle
  '1f534', // 🔴 red circle
  '1f535', // 🔵 blue circle
  '1f600', // 😀 grinning face
  '1f601', // 😁 beaming face with smiling eyes
  '1f602', // 😂 face with tears of joy
  '1f923', // 🤣 rolling on the floor laughing
  '1f603', // 😃 grinning face with big eyes
  '1f604', // 😄 grinning face with smiling eyes
  '1f605', // 😅 grinning face with sweat
  '1f606', // 😆 grinning squinting face
  '1f609', // 😉 winking face
  '1f60a', // 😊 smiling face with smiling eyes
  '1f60b', // 😋 face savoring food
  '1f60e', // 😎 smiling face with sunglasses
  '1f60d', // 😍 smiling face with heart-eyes
  '1f618', // 😘 face blowing a kiss
  '1f617', // 😗 kissing face
  '1f619', // 😙 kissing face with smiling eyes
  '1f61a', // 😚 kissing face with closed eyes
  '263a-fe0f', // ☺️ smiling face
  '1f642', // 🙂 slightly smiling face
  '1f917', // 🤗 smiling face with open hands
  '1f914', // 🤔 thinking face
  '1f610', // 😐️ neutral face
  '1f611', // 😑 expressionless face
  '1f636', // 😶 face without mouth
  '1f644', // 🙄 face with rolling eyes
  '1f60f', // 😏 smirking face
  '1f623', // 😣 persevering face
  '1f625', // 😥 sad but relieved face
  '1f62e', // 😮 face with open mouth
  '1f910', // 🤐 zipper-mouth face
  '1f62f', // 😯 hushed face
  '1f62a', // 😪 sleepy face
  '1f62b', // 😫 tired face
  '1f634', // 😴 sleeping face
  '1f60c', // 😌 relieved face
  '1f913', // 🤓 nerd face
  '1f61b', // 😛 face with tongue
  '1f61c', // 😜 winking face with tongue
  '1f61d', // 😝 squinting face with tongue
  '1f924', // 🤤 drooling face
  '1f612', // 😒 unamused face
  '1f613', // 😓 downcast face with sweat
  '1f614', // 😔 pensive face
  '1f615', // 😕 confused face
  '1f643', // 🙃 upside-down face
  '1f911', // 🤑 money-mouth face
  '1f632', // 😲 astonished face
  '2639-fe0f', // ☹️ frowning face
  '1f641', // 🙁 slightly frowning face
  '1f616', // 😖 confounded face
  '1f61e', // 😞 disappointed face
  '1f61f', // 😟 worried face
  '1f624', // 😤 face with steam from nose
  '1f622', // 😢 crying face
  '1f62d', // 😭 loudly crying face
  '1f626', // 😦 frowning face with open mouth
  '1f627', // 😧 anguished face
  '1f628', // 😨 fearful face
  '1f629', // 😩 weary face
  '1f62c', // 😬 grimacing face
  '1f630', // 😰 anxious face with sweat
  '1f631', // 😱 face screaming in fear
  '1f633', // 😳 flushed face
  '1f635', // 😵 face with crossed-out eyes
  '1f621', // 😡 enraged face
  '1f620', // 😠 angry face
  '1f607', // 😇 smiling face with halo
  '1f920', // 🤠 cowboy hat face
  '1f921', // 🤡 clown face
  '1f925', // 🤥 lying face
  '1f637', // 😷 face with medical mask
  '1f912', // 🤒 face with thermometer
  '1f915', // 🤕 face with head-bandage
  '1f922', // 🤢 nauseated face
  '1f927', // 🤧 sneezing face
  '1f608', // 😈 smiling face with horns
  '1f47f', // 👿 angry face with horns
  '1f479', // 👹 ogre
  '1f47a', // 👺 goblin
  '1f480', // 💀 skull
  '1f47b', // 👻 ghost
  '1f47d', // 👽️ alien
  '1f916', // 🤖 robot
  '1f4a9', // 💩 pile of poo
  '1f63a', // 😺 grinning cat
  '1f638', // 😸 grinning cat with smiling eyes
  '1f639', // 😹 cat with tears of joy
  '1f63b', // 😻 smiling cat with heart-eyes
  '1f63c', // 😼 cat with wry smile
  '1f63d', // 😽 kissing cat
  '1f640', // 🙀 weary cat
  '1f63f', // 😿 crying cat
  '1f63e', // 😾 pouting cat
  '1f46f', // 👯 people with bunny ears
  '1f5e3-fe0f', // 🗣️ speaking head
  '1f464', // 👤 bust in silhouette
  '1f465', // 👥 busts in silhouette
  '1f46b', // 👫 woman and man holding hands
  '1f46c', // 👬 men holding hands
  '1f46d', // 👭 women holding hands
  '1f48f', // 💏 kiss
  '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468', // 👨‍❤️‍💋‍👨 kiss: man, man
  '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469', // 👩‍❤️‍💋‍👩 kiss: woman, woman
  '1f491', // 💑 couple with heart
  '1f468-200d-2764-fe0f-200d-1f468', // 👨‍❤️‍👨 couple with heart: man, man
  '1f469-200d-2764-fe0f-200d-1f469', // 👩‍❤️‍👩 couple with heart: woman, woman
  '1f46a', // 👪️ family
  '1f468-200d-1f469-200d-1f467', // 👨‍👩‍👧 family: man, woman, girl
  '1f468-200d-1f469-200d-1f467-200d-1f466', // 👨‍👩‍👧‍👦 family: man, woman, girl, boy
  '1f468-200d-1f469-200d-1f466-200d-1f466', // 👨‍👩‍👦‍👦 family: man, woman, boy, boy
  '1f468-200d-1f469-200d-1f467-200d-1f467', // 👨‍👩‍👧‍👧 family: man, woman, girl, girl
  '1f468-200d-1f468-200d-1f466', // 👨‍👨‍👦 family: man, man, boy
  '1f468-200d-1f468-200d-1f467', // 👨‍👨‍👧 family: man, man, girl
  '1f468-200d-1f468-200d-1f467-200d-1f466', // 👨‍👨‍👧‍👦 family: man, man, girl, boy
  '1f468-200d-1f468-200d-1f466-200d-1f466', // 👨‍👨‍👦‍👦 family: man, man, boy, boy
  '1f468-200d-1f468-200d-1f467-200d-1f467', // 👨‍👨‍👧‍👧 family: man, man, girl, girl
  '1f469-200d-1f469-200d-1f466', // 👩‍👩‍👦 family: woman, woman, boy
  '1f469-200d-1f469-200d-1f467', // 👩‍👩‍👧 family: woman, woman, girl
  '1f469-200d-1f469-200d-1f467-200d-1f466', // 👩‍👩‍👧‍👦 family: woman, woman, girl, boy
  '1f469-200d-1f469-200d-1f466-200d-1f466', // 👩‍👩‍👦‍👦 family: woman, woman, boy, boy
  '1f469-200d-1f469-200d-1f467-200d-1f467', // 👩‍👩‍👧‍👧 family: woman, woman, girl, girl
  '1f463', // 👣 footprints
  '1f440', // 👀 eyes
  '1f441-fe0f', // 👁️ eye
  '1f445', // 👅 tongue
  '1f444', // 👄 mouth
  '1f48b', // 💋 kiss mark
  '1f4a4', // 💤 ZZZ
  '1f453', // 👓️ glasses
  '1f576-fe0f', // 🕶️ sunglasses
  '1f454', // 👔 necktie
  '1f455', // 👕 t-shirt
  '1f456', // 👖 jeans
  '1f457', // 👗 dress
  '1f458', // 👘 kimono
  '1f459', // 👙 bikini
  '1f45a', // 👚 woman’s clothes
  '1f45b', // 👛 purse
  '1f45c', // 👜 handbag
  '1f45d', // 👝 clutch bag
  '1f392', // 🎒 backpack
  '1f45e', // 👞 man’s shoe
  '1f45f', // 👟 running shoe
  '1f460', // 👠 high-heeled shoe
  '1f461', // 👡 woman’s sandal
  '1f462', // 👢 woman’s boot
  '1f451', // 👑 crown
  '1f452', // 👒 woman’s hat
  '1f3a9', // 🎩 top hat
  '1f393', // 🎓️ graduation cap
  '26d1-fe0f', // ⛑️ rescue worker’s helmet
  '1f484', // 💄 lipstick
  '1f48d', // 💍 ring
  '1f302', // 🌂 closed umbrella
  '1f4bc', // 💼 briefcase
  '1f44b', // 👋 waving hand
  '1f91a', // 🤚 raised back of hand
  '1f590-fe0f', // 🖐️ hand with fingers splayed
  '270b-fe0f', // ✋️ raised hand
  '1f596', // 🖖 vulcan salute
  '1faf1', // 🫱 rightwards hand
  '1FAF2', // 🫲 leftwards hand
  '1FAF3', // 🫳 palm down hand
  '1FAF4', // 🫴 palm up hand
  '1FAF7', // 🫷 leftwards pushing hand
  '1faF8', // 🫸 rightwards pushing hand
  '1f44c', // 👌 OK hand
  '1f90c', // 🤌 pinched fingers
  '1f90f', // 🤏 pinching hand
  '270c-fe0f', // ✌️ victory hand
  '1f91e', // 🤞 crossed fingers
  '1faf0', // 🫰 index finger & thumb crossed
  '1f91f', // 🤟 love-you gesture
  '1f918', // 🤘 sign of the horns
  '1f919', // 🤙 call me hand
  '1f448-fe0f', // 👈️ backhand index pointing left
  '1f449-fe0f', // 👉️ backhand index pointing right
  '1f446-fe0f', // 👆️ backhand index pointing up
  '1f595', // 🖕 middle finger
  '1f447-fe0f', // 👇️ backhand index pointing down
  '261d-fe0f', // ☝️ index pointing up
  '1faf5', // 🫵 pointing at the viewer
  '1f44d-fe0f', // 👍️ thumbs up
  '1f44e-fe0f', // 👎️ thumbs down
  '270a-fe0f', // ✊️ raised fist
  '1f44a', // 👊 oncoming fist
  '1f44f', // 👏 clapping hands
  '1f64c', // 🙌 raising hands
  '1faf6', // 🫶 heart hands
  '1f450', // 👐 open hands
  '1f932', // 🤲 palms up together
  '1f91d', // 🤝 handshake
  '1f64f', // 🙏 folded hands
  '270d-fe0f', // ✍️ writing hand
  '2620-fe0f', // ☠️ skull and crossbones
  '1f48c', // 💌 love letter
  '1f4a3', // 💣️ bomb
  '1f573-fe0f', // 🕳️ hole
  '1f6cd-fe0f', // 🛍️ shopping bags
  '1f4ff', // 📿 prayer beads
  '1f48e', // 💎 gem stone
  '1f52a', // 🔪 kitchen knife
  '1f3fa', // 🏺 amphora
  '1f5fa-fe0f', // 🗺️ world map
  '1f488', // 💈 barber pole
  '1f5bc-fe0f', // 🖼️ framed picture
  '1f6ce-fe0f', // 🛎️ bellhop bell
  '1f6aa', // 🚪 door
  '1f6cc', // 🛌 person in bed
  '1f6cf-fe0f', // 🛏️ bed
  '1f6cb-fe0f', // 🛋️ couch and lamp
  '1f6bd', // 🚽 toilet
  '1f6bf', // 🚿 shower
  '1f6c1', // 🛁 bathtub
  '231b-fe0f', // ⌛️ hourglass done
  '23f3', // ⏳️ hourglass not done
  '231a-fe0f', // ⌚️ watch
  '23f0', // ⏰️ alarm clock
  '23f1-fe0f', // ⏱️ stopwatch
  '23f2-fe0f', // ⏲️ timer clock
  '1f570-fe0f', // 🕰️ mantelpiece clock
  '1f321-fe0f', // 🌡️ thermometer
  '26f1-fe0f', // ⛱️ umbrella on ground
  '1f388', // 🎈 balloon
  '1f389', // 🎉 party popper
  '1f38a', // 🎊 confetti ball
  '1f38e', // 🎎 Japanese dolls
  '1f38f', // 🎏 carp streamer
  '1f390', // 🎐 wind chime
  '1f380', // 🎀 ribbon
  '1f381', // 🎁 wrapped gift
  '1f579-fe0f', // 🕹️ joystick
  '1f4ef', // 📯 postal horn
  '1f399-fe0f', // 🎙️ studio microphone
  '1f39a-fe0f', // 🎚️ level slider
  '1f39b-fe0f', // 🎛️ control knobs
  '1f4fb', // 📻️ radio
  '1f4f1', // 📱 mobile phone
  '1f4f2', // 📲 mobile phone with arrow
  '260e-fe0f', // ☎️ telephone
  '1f4de', // 📞 telephone receiver
  '1f4df', // 📟️ pager
  '1f4e0', // 📠 fax machine
  '1f50b', // 🔋 battery
  '1f50c', // 🔌 electric plug
  '1f4bb', // 💻️ laptop
  '1f5a5-fe0f', // 🖥️ desktop computer
  '1f5a8-fe0f', // 🖨️ printer
  '2328-fe0f', // ⌨️ keyboard
  '1f5b1-fe0f', // 🖱️ computer mouse
  '1f5b2-fe0f', // 🖲️ trackball
  '1f4bd', // 💽 computer disk
  '1f4be', // 💾 floppy disk
  '1f4bf', // 💿️ optical disk
  '1f4c0', // 📀 dvd
  '1f3a5', // 🎥 movie camera
  '1f39e-fe0f', // 🎞️ film frames
  '1f4fd-fe0f', // 📽️ film projector
  '1f4fa', // 📺️ television
  '1f4f7', // 📷️ camera
  '1f4f8', // 📸 camera with flash
  '1f4f9', // 📹️ video camera
  '1f4fc', // 📼 videocassette
  '1f50d', // 🔍️ magnifying glass tilted left
  '1f50e', // 🔎 magnifying glass tilted right
  '1f52c', // 🔬 microscope
  '1f52d', // 🔭 telescope
  '1f4e1', // 📡 satellite antenna
  '1f56f-fe0f', // 🕯️ candle
  '1f4a1', // 💡 light bulb
  '1f526', // 🔦 flashlight
  '1f3ee', // 🏮 red paper lantern
  '1f4d4', // 📔 notebook with decorative cover
  '1f4d5', // 📕 closed book
  '1f4d6', // 📖 open book
  '1f4d7', // 📗 green book
  '1f4d8', // 📘 blue book
  '1f4d9', // 📙 orange book
  '1f4da', // 📚️ books
  '1f4d3', // 📓 notebook
  '1f4d2', // 📒 ledger
  '1f4c3', // 📃 page with curl
  '1f4dc', // 📜 scroll
  '1f4c4', // 📄 page facing up
  '1f4f0', // 📰 newspaper
  '1f5de-fe0f', // 🗞️ rolled-up newspaper
  '1f4d1', // 📑 bookmark tabs
  '1f516', // 🔖 bookmark
  '1f3f7-fe0f', // 🏷️ label
  '1f4b0', // 💰️ money bag
  '1f4b4', // 💴 yen banknote
  '1f4b5', // 💵 dollar banknote
  '1f4b6', // 💶 euro banknote
  '1f4b7', // 💷 pound banknote
  '1f4b8', // 💸 money with wings
  '1f4b3', // 💳️ credit card
  '2709-fe0f', // ✉️ envelope
  '1f4e7', // 📧 e-mail
  '1f4e8', // 📨 incoming envelope
  '1f4e9', // 📩 envelope with arrow
  '1f4e4', // 📤️ outbox tray
  '1f4e5', // 📥️ inbox tray
  '1f4e6', // 📦️ package
  '1f4eb', // 📫️ closed mailbox with raised flag
  '1f4ea', // 📪️ closed mailbox with lowered flag
  '1f4ec', // 📬️ open mailbox with raised flag
  '1f4ed', // 📭️ open mailbox with lowered flag
  '1f4ee', // 📮 postbox
  '1f5f3-fe0f', // 🗳️ ballot box with ballot
  '270f-fe0f', // ✏️ pencil
  '2712-fe0f', // ✒️ black nib
  '1f58b-fe0f', // 🖋️ fountain pen
  '1f58a-fe0f', // 🖊️ pen
  '1f58c-fe0f', // 🖌️ paintbrush
  '1f58d-fe0f', // 🖍️ crayon
  '1f4dd', // 📝 memo
  '1f4c1', // 📁 file folder
  '1f4c2', // 📂 open file folder
  '1f5c2-fe0f', // 🗂️ card index dividers
  '1f4c5', // 📅 calendar
  '1f4c6', // 📆 tear-off calendar
  '1f5d2-fe0f', // 🗒️ spiral notepad
  '1f5d3-fe0f', // 🗓️ spiral calendar
  '1f4c7', // 📇 card index
  '1f4c8', // 📈 chart increasing
  '1f4c9', // 📉 chart decreasing
  '1f4ca', // 📊 bar chart
  '1f4cb', // 📋️ clipboard
  '1f4cc', // 📌 pushpin
  '1f4cd', // 📍 round pushpin
  '1f4ce', // 📎 paperclip
  '1f587-fe0f', // 🖇️ linked paperclips
  '1f4cf', // 📏 straight ruler
  '1f4d0', // 📐 triangular ruler
  '2702-fe0f', // ✂️ scissors
  '1f5c3-fe0f', // 🗃️ card file box
  '1f5c4-fe0f', // 🗄️ file cabinet
  '1f5d1-fe0f', // 🗑️ wastebasket
  '1f512', // 🔒️ locked
  '1f513', // 🔓️ unlocked
  '1f50f', // 🔏 locked with pen
  '1f510', // 🔐 locked with key
  '1f511', // 🔑 key
  '1f5dd-fe0f', // 🗝️ old key
  '1f528', // 🔨 hammer
  '26cf-fe0f', // ⛏️ pick
  '2692-fe0f', // ⚒️ hammer and pick
  '1f6e0-fe0f', // 🛠️ hammer and wrench
  '1f5e1-fe0f', // 🗡️ dagger
  '2694-fe0f', // ⚔️ crossed swords
  '1f52b', // 🔫 water pistol
  '1f6e1-fe0f', // 🛡️ shield
  '1f527', // 🔧 wrench
  '1f529', // 🔩 nut and bolt
  '2699-fe0f', // ⚙️ gear
  '1f5dc-fe0f', // 🗜️ clamp
  '2697-fe0f', // ⚗️ alembic
  '2696-fe0f', // ⚖️ balance scale
  '1f517', // 🔗 link
  '26d3-fe0f', // ⛓️ chains
  '1f489', // 💉 syringe
  '1f48a', // 💊 pill
  '1f6ac', // 🚬 cigarette
  '26b0-fe0f', // ⚰️ coffin
  '26b1-fe0f', // ⚱️ funeral urn
  '1f5ff', // 🗿 moai
  '1f6e2-fe0f', // 🛢️ oil drum
  '1f52e', // 🔮 crystal ball
  '1f6d2', // 🛒 shopping cart
  '1f6a9', // 🚩 triangular flag
  '1f38c', // 🎌 crossed flags
  '1f3f4', // 🏴 black flag
  '1f3f3-fe0f', // 🏳️ white flag
  '1f3f3-fe0f-200d-1f308', // 🏳️‍🌈 rainbow flag
  '1f47e', // 👾 alien monster
  '1f574-fe0f', // 🕴️ person in suit levitating
  '1f93a', // 🤺 person fencing
  '26f7-fe0f', // ⛷️ skier
  '1f3c2', // 🏂️ snowboarder
  '1f3cc-fe0f', // 🏌️ person golfing
  '1f3aa', // 🎪 circus tent
  '1f3ad', // 🎭️ performing arts
  '1f3a8', // 🎨 artist palette
  '1f3b0', // 🎰 slot machine
  '1f397-fe0f', // 🎗️ reminder ribbon
  '1f39f-fe0f', // 🎟️ admission tickets
  '1f3ab', // 🎫 ticket
  '1f396-fe0f', // 🎖️ military medal
  '1f3c6', // 🏆️ trophy
  '1f3c5', // 🏅 sports medal
  '1f947', // 🥇 1st place medal
  '1f948', // 🥈 2nd place medal
  '1f949', // 🥉 3rd place medal
  '26bd-fe0f', // ⚽️ soccer ball
  '26be-fe0f', // ⚾️ baseball
  '1f3c0', // 🏀 basketball
  '1f3d0', // 🏐 volleyball
  '1f3c8', // 🏈 american football
  '1f3c9', // 🏉 rugby football
  '1f3be', // 🎾 tennis
  '1f3b1', // 🎱 pool 8 ball
  '1f3b3', // 🎳 bowling
  '1f3cf', // 🏏 cricket game
  '1f3d1', // 🏑 field hockey
  '1f3d2', // 🏒 ice hockey
  '1f3d3', // 🏓 ping pong
  '1f3f8', // 🏸 badminton
  '1f94a', // 🥊 boxing glove
  '1f94b', // 🥋 martial arts uniform
  '1f945', // 🥅 goal net
  '1f3af', // 🎯 bullseye
  '26f3-fe0f', // ⛳️ flag in hole
  '26f8-fe0f', // ⛸️ ice skate
  '1f3a3', // 🎣 fishing pole
  '1f3bd', // 🎽 running shirt
  '1f3bf', // 🎿 skis
  '1f3ae', // 🎮️ video game
  '1f3b2', // 🎲 game die
  '1f3bc', // 🎼 musical score
  '1f3a4', // 🎤 microphone
  '1f3a7', // 🎧️ headphone
  '1f3b7', // 🎷 saxophone
  '1f3b8', // 🎸 guitar
  '1f3b9', // 🎹 musical keyboard
  '1f3ba', // 🎺 trumpet
  '1f3bb', // 🎻 violin
  '1f941', // 🥁 drum
  '1f3ac', // 🎬️ clapper board
  '1f3f9', // 🏹 bow and arrow
  '1f648', // 🙈 see-no-evil monkey
  '1f649', // 🙉 hear-no-evil monkey
  '1f64a', // 🙊 speak-no-evil monkey
  '1f4a6', // 💦 sweat droplets
  '1f4a8', // 💨 dashing away
  '1f435', // 🐵 monkey face
  '1f412', // 🐒 monkey
  '1f98d', // 🦍 gorilla
  '1f436', // 🐶 dog face
  '1f415', // 🐕️ dog
  '1f429', // 🐩 poodle
  '1f43a', // 🐺 wolf
  '1f98a', // 🦊 fox
  '1f431', // 🐱 cat face
  '1f408', // 🐈️ cat
  '1f981', // 🦁 lion
  '1f42f', // 🐯 tiger face
  '1f405', // 🐅 tiger
  '1f406', // 🐆 leopard
  '1f434', // 🐴 horse face
  '1f40e', // 🐎 horse
  '1f98c', // 🦌 deer
  '1f984', // 🦄 unicorn
  '1f42e', // 🐮 cow face
  '1f402', // 🐂 ox
  '1f403', // 🐃 water buffalo
  '1f404', // 🐄 cow
  '1f437', // 🐷 pig face
  '1f416', // 🐖 pig
  '1f417', // 🐗 boar
  '1f43d', // 🐽 pig nose
  '1f40f', // 🐏 ram
  '1f411', // 🐑 ewe
  '1f410', // 🐐 goat
  '1f42a', // 🐪 camel
  '1f42b', // 🐫 two-hump camel
  '1f418', // 🐘 elephant
  '1f98f', // 🦏 rhinoceros
  '1f42d', // 🐭 mouse face
  '1f401', // 🐁 mouse
  '1f400', // 🐀 rat
  '1f439', // 🐹 hamster
  '1f430', // 🐰 rabbit face
  '1f407', // 🐇 rabbit
  '1f43f-fe0f', // 🐿️ chipmunk
  '1f987', // 🦇 bat
  '1f43b', // 🐻 bear
  '1f428', // 🐨 koala
  '1f43c', // 🐼 panda
  '1f43e', // 🐾 paw prints
  '1f983', // 🦃 turkey
  '1f414', // 🐔 chicken
  '1f413', // 🐓 rooster
  '1f423', // 🐣 hatching chick
  '1f424', // 🐤 baby chick
  '1f425', // 🐥 front-facing baby chick
  '1f426', // 🐦️ bird
  '1f427', // 🐧 penguin
  '1f54a-fe0f', // 🕊️ dove
  '1f985', // 🦅 eagle
  '1f986', // 🦆 duck
  '1f989', // 🦉 owl
  '1f438', // 🐸 frog
  '1f40a', // 🐊 crocodile
  '1f422', // 🐢 turtle
  '1f98e', // 🦎 lizard
  '1f40d', // 🐍 snake
  '1f432', // 🐲 dragon face
  '1f409', // 🐉 dragon
  '1f433', // 🐳 spouting whale
  '1f40b', // 🐋 whale
  '1f42c', // 🐬 dolphin
  '1f41f', // 🐟️ fish
  '1f420', // 🐠 tropical fish
  '1f421', // 🐡 blowfish
  '1f988', // 🦈 shark
  '1f419', // 🐙 octopus
  '1f41a', // 🐚 spiral shell
  '1f980', // 🦀 crab
  '1f990', // 🦐 shrimp
  '1f991', // 🦑 squid
  '1f98b', // 🦋 butterfly
  '1f40c', // 🐌 snail
  '1f41b', // 🐛 bug
  '1f41c', // 🐜 ant
  '1f41d', // 🐝 honeybee
  '1f41e', // 🐞 lady beetle
  '1f577-fe0f', // 🕷️ spider
  '1f578-fe0f', // 🕸️ spider web
  '1f982', // 🦂 scorpion
  '1f490', // 💐 bouquet
  '1f338', // 🌸 cherry blossom
  '1f3f5-fe0f', // 🏵️ rosette
  '1f339', // 🌹 rose
  '1f940', // 🥀 wilted flower
  '1f33a', // 🌺 hibiscus
  '1f33b', // 🌻 sunflower
  '1f33c', // 🌼 blossom
  '1f337', // 🌷 tulip
  '1f331', // 🌱 seedling
  '1f332', // 🌲 evergreen tree
  '1f333', // 🌳 deciduous tree
  '1f334', // 🌴 palm tree
  '1f335', // 🌵 cactus
  '1f33e', // 🌾 sheaf of rice
  '1f33f', // 🌿 herb
  '2618-fe0f', // ☘️ shamrock
  '1f340', // 🍀 four leaf clover
  '1f341', // 🍁 maple leaf
  '1f342', // 🍂 fallen leaf
  '1f343', // 🍃 leaf fluttering in wind
  '1f344', // 🍄 mushroom
  '1f330', // 🌰 chestnut
  '1f30d', // 🌍️ globe showing Europe-Africa
  '1f30e', // 🌎️ globe showing Americas
  '1f30f', // 🌏️ globe showing Asia-Australia
  '1f311', // 🌑 new moon
  '1f312', // 🌒 waxing crescent moon
  '1f313', // 🌓 first quarter moon
  '1f314', // 🌔 waxing gibbous moon
  '1f315', // 🌕️ full moon
  '1f316', // 🌖 waning gibbous moon
  '1f317', // 🌗 last quarter moon
  '1f318', // 🌘 waning crescent moon
  '1f319', // 🌙 crescent moon
  '1f31a', // 🌚 new moon face
  '1f31b', // 🌛 first quarter moon face
  '1f31c', // 🌜️ last quarter moon face
  '2600-fe0f', // ☀️ sun
  '1f31d', // 🌝 full moon face
  '1f31e', // 🌞 sun with face
  '2b50-fe0f', // ⭐️ star
  '1f31f', // 🌟 glowing star
  '2601-fe0f', // ☁️ cloud
  '26c5-fe0f', // ⛅️ sun behind cloud
  '26c8-fe0f', // ⛈️ cloud with lightning and rain
  '1f324-fe0f', // 🌤️ sun behind small cloud
  '1f325-fe0f', // 🌥️ sun behind large cloud
  '1f326-fe0f', // 🌦️ sun behind rain cloud
  '1f327-fe0f', // 🌧️ cloud with rain
  '1f328-fe0f', // 🌨️ cloud with snow
  '1f329-fe0f', // 🌩️ cloud with lightning
  '1f32a-fe0f', // 🌪️ tornado
  '1f32b-fe0f', // 🌫️ fog
  '1f32c-fe0f', // 🌬️ wind face
  '2602-fe0f', // ☂️ umbrella
  '2614-fe0f', // ☔️ umbrella with rain drops
  '26a1-fe0f', // ⚡️ high voltage
  '2744-fe0f', // ❄️ snowflake
  '2603-fe0f', // ☃️ snowman
  '26c4-fe0f', // ⛄️ snowman without snow
  '2604-fe0f', // ☄️ comet
  '1f525', // 🔥 fire
  '1f4a7', // 💧 droplet
  '1f30a', // 🌊 water wave
  '1f383', // 🎃 jack-o-lantern
  '1f384', // 🎄 Christmas tree
  '2728', // ✨️ sparkles
  '1f38b', // 🎋 tanabata tree
  '1f38d', // 🎍 pine decoration
  '1f3ce-fe0f', // 🏎️ racing car
  '1f3cd-fe0f', // 🏍️ motorcycle
  '1f5fe', // 🗾 map of Japan
  '1f3d4-fe0f', // 🏔️ snow-capped mountain
  '26f0-fe0f', // ⛰️ mountain
  '1f30b', // 🌋 volcano
  '1f5fb', // 🗻 mount fuji
  '1f3d5-fe0f', // 🏕️ camping
  '1f3d6-fe0f', // 🏖️ beach with umbrella
  '1f3dc-fe0f', // 🏜️ desert
  '1f3dd-fe0f', // 🏝️ desert island
  '1f3de-fe0f', // 🏞️ national park
  '1f3df-fe0f', // 🏟️ stadium
  '1f3db-fe0f', // 🏛️ classical building
  '1f3d7-fe0f', // 🏗️ building construction
  '1f3d8-fe0f', // 🏘️ houses
  '1f3d9-fe0f', // 🏙️ cityscape
  '1f3da-fe0f', // 🏚️ derelict house
  '1f3e0', // 🏠️ house
  '1f3e1', // 🏡 house with garden
  '1f3e2', // 🏢 office building
  '1f3e3', // 🏣 Japanese post office
  '1f3e4', // 🏤 post office
  '1f3e5', // 🏥 hospital
  '1f3e6', // 🏦 bank
  '1f3e8', // 🏨 hotel
  '1f3e9', // 🏩 love hotel
  '1f3ea', // 🏪 convenience store
  '1f3eb', // 🏫 school
  '1f3ec', // 🏬 department store
  '1f3ed', // 🏭️ factory
  '1f3ef', // 🏯 Japanese castle
  '1f3f0', // 🏰 castle
  '1f492', // 💒 wedding
  '1f5fc', // 🗼 Tokyo tower
  '1f5fd', // 🗽 Statue of Liberty
  '26ea-fe0f', // ⛪️ church
  '1f54c', // 🕌 mosque
  '1f54d', // 🕍 synagogue
  '26e9-fe0f', // ⛩️ shinto shrine
  '1f54b', // 🕋 kaaba
  '26f2-fe0f', // ⛲️ fountain
  '26fa-fe0f', // ⛺️ tent
  '1f301', // 🌁 foggy
  '1f303', // 🌃 night with stars
  '1f304', // 🌄 sunrise over mountains
  '1f305', // 🌅 sunrise
  '1f306', // 🌆 cityscape at dusk
  '1f307', // 🌇 sunset
  '1f309', // 🌉 bridge at night
  '1f30c', // 🌌 milky way
  '1f3a0', // 🎠 carousel horse
  '1f3a1', // 🎡 ferris wheel
  '1f3a2', // 🎢 roller coaster
  '1f682', // 🚂 locomotive
  '1f683', // 🚃 railway car
  '1f684', // 🚄 high-speed train
  '1f685', // 🚅 bullet train
  '1f686', // 🚆 train
  '1f687', // 🚇️ metro
  '1f688', // 🚈 light rail
  '1f689', // 🚉 station
  '1f68a', // 🚊 tram
  '1f69d', // 🚝 monorail
  '1f69e', // 🚞 mountain railway
  '1f68b', // 🚋 tram car
  '1f68c', // 🚌 bus
  '1f68d', // 🚍️ oncoming bus
  '1f68e', // 🚎 trolleybus
  '1f690', // 🚐 minibus
  '1f691', // 🚑️ ambulance
  '1f692', // 🚒 fire engine
  '1f693', // 🚓 police car
  '1f694', // 🚔️ oncoming police car
  '1f695', // 🚕 taxi
  '1f696', // 🚖 oncoming taxi
  '1f697', // 🚗 automobile
  '1f698', // 🚘️ oncoming automobile
  '1f699', // 🚙 sport utility vehicle
  '1f69a', // 🚚 delivery truck
  '1f69b', // 🚛 articulated lorry
  '1f69c', // 🚜 tractor
  '1f6b2', // 🚲️ bicycle
  '1f6f4', // 🛴 kick scooter
  '1f6f5', // 🛵 motor scooter
  '1f68f', // 🚏 bus stop
  '1f6e3-fe0f', // 🛣️ motorway
  '1f6e4-fe0f', // 🛤️ railway track
  '26fd-fe0f', // ⛽️ fuel pump
  '1f6a8', // 🚨 police car light
  '1f6a5', // 🚥 horizontal traffic light
  '1f6a6', // 🚦 vertical traffic light
  '1f6a7', // 🚧 construction
  '2693-fe0f', // ⚓️ anchor
  '26f5-fe0f', // ⛵️ sailboat
  '1f6f6', // 🛶 canoe
  '1f6a4', // 🚤 speedboat
  '1f6f3-fe0f', // 🛳️ passenger ship
  '26f4-fe0f', // ⛴️ ferry
  '1f6e5-fe0f', // 🛥️ motor boat
  '1f6a2', // 🚢 ship
  '2708-fe0f', // ✈️ airplane
  '1f6e9-fe0f', // 🛩️ small airplane
  '1f6eb', // 🛫 airplane departure
  '1f6ec', // 🛬 airplane arrival
  '1f4ba', // 💺 seat
  '1f681', // 🚁 helicopter
  '1f69f', // 🚟 suspension railway
  '1f6a0', // 🚠 mountain cableway
  '1f6a1', // 🚡 aerial tramway
  '1f680', // 🚀 rocket
  '1f6f0-fe0f', // 🛰️ satellite
  '1f320', // 🌠 shooting star
  '1f308', // 🌈 rainbow
  '1f386', // 🎆 fireworks
  '1f387', // 🎇 sparkler
  '1f391', // 🎑 moon viewing ceremony
  '1f3c1', // 🏁 chequered flag
  '1f347', // 🍇 grapes
  '1f348', // 🍈 melon
  '1f349', // 🍉 watermelon
  '1f34a', // 🍊 tangerine
  '1f34b', // 🍋 lemon
  '1f34c', // 🍌 banana
  '1f34d', // 🍍 pineapple
  '1f34e', // 🍎 red apple
  '1f34f', // 🍏 green apple
  '1f350', // 🍐 pear
  '1f351', // 🍑 peach
  '1f352', // 🍒 cherries
  '1f353', // 🍓 strawberry
  '1f95d', // 🥝 kiwi fruit
  '1f345', // 🍅 tomato
  '1f951', // 🥑 avocado
  '1f346', // 🍆 eggplant
  '1f954', // 🥔 potato
  '1f955', // 🥕 carrot
  '1f33d', // 🌽 ear of corn
  '1f336-fe0f', // 🌶️ hot pepper
  '1f952', // 🥒 cucumber
  '1f95c', // 🥜 peanuts
  '1f35e', // 🍞 bread
  '1f950', // 🥐 croissant
  '1f956', // 🥖 baguette bread
  '1f95e', // 🥞 pancakes
  '1f9c0', // 🧀 cheese wedge
  '1f356', // 🍖 meat on bone
  '1f357', // 🍗 poultry leg
  '1f953', // 🥓 bacon
  '1f354', // 🍔 hamburger
  '1f35f', // 🍟 french fries
  '1f355', // 🍕 pizza
  '1f32d', // 🌭 hot dog
  '1f32e', // 🌮 taco
  '1f32f', // 🌯 burrito
  '1f959', // 🥙 stuffed flatbread
  '1f95a', // 🥚 egg
  '1f373', // 🍳 cooking
  '1f958', // 🥘 shallow pan of food
  '1f372', // 🍲 pot of food
  '1f957', // 🥗 green salad
  '1f37f', // 🍿 popcorn
  '1f371', // 🍱 bento box
  '1f358', // 🍘 rice cracker
  '1f359', // 🍙 rice ball
  '1f35a', // 🍚 cooked rice
  '1f35b', // 🍛 curry rice
  '1f35c', // 🍜 steaming bowl
  '1f35d', // 🍝 spaghetti
  '1f360', // 🍠 roasted sweet potato
  '1f362', // 🍢 oden
  '1f363', // 🍣 sushi
  '1f364', // 🍤 fried shrimp
  '1f365', // 🍥 fish cake with swirl
  '1f361', // 🍡 dango
  '1f366', // 🍦 soft ice cream
  '1f367', // 🍧 shaved ice
  '1f368', // 🍨 ice cream
  '1f369', // 🍩 doughnut
  '1f36a', // 🍪 cookie
  '1f382', // 🎂 birthday cake
  '1f370', // 🍰 shortcake
  '1f36b', // 🍫 chocolate bar
  '1f36c', // 🍬 candy
  '1f36d', // 🍭 lollipop
  '1f36e', // 🍮 custard
  '1f36f', // 🍯 honey pot
  '1f37c', // 🍼 baby bottle
  '1f95b', // 🥛 glass of milk
  '2615-fe0f', // ☕️ hot beverage
  '1f375', // 🍵 teacup without handle
  '1f376', // 🍶 sake
  '1f37e', // 🍾 bottle with popping cork
  '1f377', // 🍷 wine glass
  '1f378', // 🍸️ cocktail glass
  '1f379', // 🍹 tropical drink
  '1f37a', // 🍺 beer mug
  '1f37b', // 🍻 clinking beer mugs
  '1f942', // 🥂 clinking glasses
  '1f943', // 🥃 tumbler glass
  '1f37d-fe0f', // 🍽️ fork and knife with plate
  '1f374', // 🍴 fork and knife
  '1f944', // 🥄 spoon
  '1f1e6-1f1e8', // 🇦🇨 flag: Ascension Island
  '1f1e6-1f1e9', // 🇦🇩 flag: Andorra
  '1f1e6-1f1ea', // 🇦🇪 flag: United Arab Emirates
  '1f1e6-1f1eb', // 🇦🇫 flag: Afghanistan
  '1f1e6-1f1ec', // 🇦🇬 flag: Antigua & Barbuda
  '1f1e6-1f1ee', // 🇦🇮 flag: Anguilla
  '1f1e6-1f1f1', // 🇦🇱 flag: Albania
  '1f1e6-1f1f2', // 🇦🇲 flag: Armenia
  '1f1e6-1f1f4', // 🇦🇴 flag: Angola
  '1f1e6-1f1f6', // 🇦🇶 flag: Antarctica
  '1f1e6-1f1f7', // 🇦🇷 flag: Argentina
  '1f1e6-1f1f8', // 🇦🇸 flag: American Samoa
  '1f1e6-1f1f9', // 🇦🇹 flag: Austria
  '1f1e6-1f1fa', // 🇦🇺 flag: Australia
  '1f1e6-1f1fc', // 🇦🇼 flag: Aruba
  '1f1e6-1f1fd', // 🇦🇽 flag: Åland Islands
  '1f1e6-1f1ff', // 🇦🇿 flag: Azerbaijan
  '1f1e7-1f1e6', // 🇧🇦 flag: Bosnia & Herzegovina
  '1f1e7-1f1e7', // 🇧🇧 flag: Barbados
  '1f1e7-1f1e9', // 🇧🇩 flag: Bangladesh
  '1f1e7-1f1ea', // 🇧🇪 flag: Belgium
  '1f1e7-1f1eb', // 🇧🇫 flag: Burkina Faso
  '1f1e7-1f1ec', // 🇧🇬 flag: Bulgaria
  '1f1e7-1f1ed', // 🇧🇭 flag: Bahrain
  '1f1e7-1f1ee', // 🇧🇮 flag: Burundi
  '1f1e7-1f1ef', // 🇧🇯 flag: Benin
  '1f1e7-1f1f1', // 🇧🇱 flag: St. Barthélemy
  '1f1e7-1f1f2', // 🇧🇲 flag: Bermuda
  '1f1e7-1f1f3', // 🇧🇳 flag: Brunei
  '1f1e7-1f1f4', // 🇧🇴 flag: Bolivia
  '1f1e7-1f1f6', // 🇧🇶 flag: Caribbean Netherlands
  '1f1e7-1f1f7', // 🇧🇷 flag: Brazil
  '1f1e7-1f1f8', // 🇧🇸 flag: Bahamas
  '1f1e7-1f1f9', // 🇧🇹 flag: Bhutan
  '1f1e7-1f1fb', // 🇧🇻 flag: Bouvet Island
  '1f1e7-1f1fc', // 🇧🇼 flag: Botswana
  '1f1e7-1f1fe', // 🇧🇾 flag: Belarus
  '1f1e7-1f1ff', // 🇧🇿 flag: Belize
  '1f1e8-1f1e6', // 🇨🇦 flag: Canada
  '1f1e8-1f1e8', // 🇨🇨 flag: Cocos (Keeling) Islands
  '1f1e8-1f1e9', // 🇨🇩 flag: Congo - Kinshasa
  '1f1e8-1f1eb', // 🇨🇫 flag: Central African Republic
  '1f1e8-1f1ec', // 🇨🇬 flag: Congo - Brazzaville
  '1f1e8-1f1ed', // 🇨🇭 flag: Switzerland
  '1f1e8-1f1ee', // 🇨🇮 flag: Côte d’Ivoire
  '1f1e8-1f1f0', // 🇨🇰 flag: Cook Islands
  '1f1e8-1f1f1', // 🇨🇱 flag: Chile
  '1f1e8-1f1f2', // 🇨🇲 flag: Cameroon
  '1f1e8-1f1f3', // 🇨🇳 flag: China
  '1f1e8-1f1f4', // 🇨🇴 flag: Colombia
  '1f1e8-1f1f5', // 🇨🇵 flag: Clipperton Island
  '1f1e8-1f1f7', // 🇨🇷 flag: Costa Rica
  '1f1e8-1f1fa', // 🇨🇺 flag: Cuba
  '1f1e8-1f1fb', // 🇨🇻 flag: Cape Verde
  '1f1e8-1f1fc', // 🇨🇼 flag: Curaçao
  '1f1e8-1f1fd', // 🇨🇽 flag: Christmas Island
  '1f1e8-1f1fe', // 🇨🇾 flag: Cyprus
  '1f1e8-1f1ff', // 🇨🇿 flag: Czechia
  '1f1e9-1f1ea', // 🇩🇪 flag: Germany
  '1f1e9-1f1ec', // 🇩🇬 flag: Diego Garcia
  '1f1e9-1f1ef', // 🇩🇯 flag: Djibouti
  '1f1e9-1f1f0', // 🇩🇰 flag: Denmark
  '1f1e9-1f1f2', // 🇩🇲 flag: Dominica
  '1f1e9-1f1f4', // 🇩🇴 flag: Dominican Republic
  '1f1e9-1f1ff', // 🇩🇿 flag: Algeria
  '1f1ea-1f1e6', // 🇪🇦 flag: Ceuta & Melilla
  '1f1ea-1f1e8', // 🇪🇨 flag: Ecuador
  '1f1ea-1f1ea', // 🇪🇪 flag: Estonia
  '1f1ea-1f1ec', // 🇪🇬 flag: Egypt
  '1f1ea-1f1ed', // 🇪🇭 flag: Western Sahara
  '1f1ea-1f1f7', // 🇪🇷 flag: Eritrea
  '1f1ea-1f1f8', // 🇪🇸 flag: Spain
  '1f1ea-1f1f9', // 🇪🇹 flag: Ethiopia
  '1f1ea-1f1fa', // 🇪🇺 flag: European Union
  '1f1eb-1f1ee', // 🇫🇮 flag: Finland
  '1f1eb-1f1ef', // 🇫🇯 flag: Fiji
  '1f1eb-1f1f0', // 🇫🇰 flag: Falkland Islands
  '1f1eb-1f1f2', // 🇫🇲 flag: Micronesia
  '1f1eb-1f1f4', // 🇫🇴 flag: Faroe Islands
  '1f1eb-1f1f7', // 🇫🇷 flag: France
  '1f1ec-1f1e6', // 🇬🇦 flag: Gabon
  '1f1ec-1f1e7', // 🇬🇧 flag: United Kingdom
  '1f1ec-1f1e9', // 🇬🇩 flag: Grenada
  '1f1ec-1f1ea', // 🇬🇪 flag: Georgia
  '1f1ec-1f1eb', // 🇬🇫 flag: French Guiana
  '1f1ec-1f1ec', // 🇬🇬 flag: Guernsey
  '1f1ec-1f1ed', // 🇬🇭 flag: Ghana
  '1f1ec-1f1ee', // 🇬🇮 flag: Gibraltar
  '1f1ec-1f1f1', // 🇬🇱 flag: Greenland
  '1f1ec-1f1f2', // 🇬🇲 flag: Gambia
  '1f1ec-1f1f3', // 🇬🇳 flag: Guinea
  '1f1ec-1f1f5', // 🇬🇵 flag: Guadeloupe
  '1f1ec-1f1f6', // 🇬🇶 flag: Equatorial Guinea
  '1f1ec-1f1f7', // 🇬🇷 flag: Greece
  '1f1ec-1f1f8', // 🇬🇸 flag: South Georgia & South Sandwich Islands
  '1f1ec-1f1f9', // 🇬🇹 flag: Guatemala
  '1f1ec-1f1fa', // 🇬🇺 flag: Guam
  '1f1ec-1f1fc', // 🇬🇼 flag: Guinea-Bissau
  '1f1ec-1f1fe', // 🇬🇾 flag: Guyana
  '1f1ed-1f1f0', // 🇭🇰 flag: Hong Kong SAR China
  '1f1ed-1f1f2', // 🇭🇲 flag: Heard & McDonald Islands
  '1f1ed-1f1f3', // 🇭🇳 flag: Honduras
  '1f1ed-1f1f7', // 🇭🇷 flag: Croatia
  '1f1ed-1f1f9', // 🇭🇹 flag: Haiti
  '1f1ed-1f1fa', // 🇭🇺 flag: Hungary
  '1f1ee-1f1e8', // 🇮🇨 flag: Canary Islands
  '1f1ee-1f1e9', // 🇮🇩 flag: Indonesia
  '1f1ee-1f1ea', // 🇮🇪 flag: Ireland
  '1f1ee-1f1f1', // 🇮🇱 flag: Israel
  '1f1ee-1f1f2', // 🇮🇲 flag: Isle of Man
  '1f1ee-1f1f3', // 🇮🇳 flag: India
  '1f1ee-1f1f4', // 🇮🇴 flag: British Indian Ocean Territory
  '1f1ee-1f1f6', // 🇮🇶 flag: Iraq
  '1f1ee-1f1f7', // 🇮🇷 flag: Iran
  '1f1ee-1f1f8', // 🇮🇸 flag: Iceland
  '1f1ee-1f1f9', // 🇮🇹 flag: Italy
  '1f1ef-1f1ea', // 🇯🇪 flag: Jersey
  '1f1ef-1f1f2', // 🇯🇲 flag: Jamaica
  '1f1ef-1f1f4', // 🇯🇴 flag: Jordan
  '1f1ef-1f1f5', // 🇯🇵 flag: Japan
  '1f1f0-1f1ea', // 🇰🇪 flag: Kenya
  '1f1f0-1f1ec', // 🇰🇬 flag: Kyrgyzstan
  '1f1f0-1f1ed', // 🇰🇭 flag: Cambodia
  '1f1f0-1f1ee', // 🇰🇮 flag: Kiribati
  '1f1f0-1f1f2', // 🇰🇲 flag: Comoros
  '1f1f0-1f1f3', // 🇰🇳 flag: St. Kitts & Nevis
  '1f1f0-1f1f5', // 🇰🇵 flag: North Korea
  '1f1f0-1f1f7', // 🇰🇷 flag: South Korea
  '1f1f0-1f1fc', // 🇰🇼 flag: Kuwait
  '1f1f0-1f1fe', // 🇰🇾 flag: Cayman Islands
  '1f1f0-1f1ff', // 🇰🇿 flag: Kazakhstan
  '1f1f1-1f1e6', // 🇱🇦 flag: Laos
  '1f1f1-1f1e7', // 🇱🇧 flag: Lebanon
  '1f1f1-1f1e8', // 🇱🇨 flag: St. Lucia
  '1f1f1-1f1ee', // 🇱🇮 flag: Liechtenstein
  '1f1f1-1f1f0', // 🇱🇰 flag: Sri Lanka
  '1f1f1-1f1f7', // 🇱🇷 flag: Liberia
  '1f1f1-1f1f8', // 🇱🇸 flag: Lesotho
  '1f1f1-1f1f9', // 🇱🇹 flag: Lithuania
  '1f1f1-1f1fa', // 🇱🇺 flag: Luxembourg
  '1f1f1-1f1fb', // 🇱🇻 flag: Latvia
  '1f1f1-1f1fe', // 🇱🇾 flag: Libya
  '1f1f2-1f1e6', // 🇲🇦 flag: Morocco
  '1f1f2-1f1e8', // 🇲🇨 flag: Monaco
  '1f1f2-1f1e9', // 🇲🇩 flag: Moldova
  '1f1f2-1f1ea', // 🇲🇪 flag: Montenegro
  '1f1f2-1f1eb', // 🇲🇫 flag: St. Martin
  '1f1f2-1f1ec', // 🇲🇬 flag: Madagascar
  '1f1f2-1f1ed', // 🇲🇭 flag: Marshall Islands
  '1f1f2-1f1f0', // 🇲🇰 flag: North Macedonia
  '1f1f2-1f1f1', // 🇲🇱 flag: Mali
  '1f1f2-1f1f2', // 🇲🇲 flag: Myanmar (Burma)
  '1f1f2-1f1f3', // 🇲🇳 flag: Mongolia
  '1f1f2-1f1f4', // 🇲🇴 flag: Macao SAR China
  '1f1f2-1f1f5', // 🇲🇵 flag: Northern Mariana Islands
  '1f1f2-1f1f6', // 🇲🇶 flag: Martinique
  '1f1f2-1f1f7', // 🇲🇷 flag: Mauritania
  '1f1f2-1f1f8', // 🇲🇸 flag: Montserrat
  '1f1f2-1f1f9', // 🇲🇹 flag: Malta
  '1f1f2-1f1fa', // 🇲🇺 flag: Mauritius
  '1f1f2-1f1fb', // 🇲🇻 flag: Maldives
  '1f1f2-1f1fc', // 🇲🇼 flag: Malawi
  '1f1f2-1f1fd', // 🇲🇽 flag: Mexico
  '1f1f2-1f1fe', // 🇲🇾 flag: Malaysia
  '1f1f2-1f1ff', // 🇲🇿 flag: Mozambique
  '1f1f3-1f1e6', // 🇳🇦 flag: Namibia
  '1f1f3-1f1e8', // 🇳🇨 flag: New Caledonia
  '1f1f3-1f1ea', // 🇳🇪 flag: Niger
  '1f1f3-1f1eb', // 🇳🇫 flag: Norfolk Island
  '1f1f3-1f1ec', // 🇳🇬 flag: Nigeria
  '1f1f3-1f1ee', // 🇳🇮 flag: Nicaragua
  '1f1f3-1f1f1', // 🇳🇱 flag: Netherlands
  '1f1f3-1f1f4', // 🇳🇴 flag: Norway
  '1f1f3-1f1f5', // 🇳🇵 flag: Nepal
  '1f1f3-1f1f7', // 🇳🇷 flag: Nauru
  '1f1f3-1f1fa', // 🇳🇺 flag: Niue
  '1f1f3-1f1ff', // 🇳🇿 flag: New Zealand
  '1f1f4-1f1f2', // 🇴🇲 flag: Oman
  '1f1f5-1f1e6', // 🇵🇦 flag: Panama
  '1f1f5-1f1ea', // 🇵🇪 flag: Peru
  '1f1f5-1f1eb', // 🇵🇫 flag: French Polynesia
  '1f1f5-1f1ec', // 🇵🇬 flag: Papua New Guinea
  '1f1f5-1f1ed', // 🇵🇭 flag: Philippines
  '1f1f5-1f1f0', // 🇵🇰 flag: Pakistan
  '1f1f5-1f1f1', // 🇵🇱 flag: Poland
  '1f1f5-1f1f2', // 🇵🇲 flag: St. Pierre & Miquelon
  '1f1f5-1f1f3', // 🇵🇳 flag: Pitcairn Islands
  '1f1f5-1f1f7', // 🇵🇷 flag: Puerto Rico
  '1f1f5-1f1f8', // 🇵🇸 flag: Palestinian Territories
  '1f1f5-1f1f9', // 🇵🇹 flag: Portugal
  '1f1f5-1f1fc', // 🇵🇼 flag: Palau
  '1f1f5-1f1fe', // 🇵🇾 flag: Paraguay
  '1f1f6-1f1e6', // 🇶🇦 flag: Qatar
  '1f1f7-1f1ea', // 🇷🇪 flag: Réunion
  '1f1f7-1f1f4', // 🇷🇴 flag: Romania
  '1f1f7-1f1f8', // 🇷🇸 flag: Serbia
  '1f1f7-1f1fa', // 🇷🇺 flag: Russia
  '1f1f7-1f1fc', // 🇷🇼 flag: Rwanda
  '1f1f8-1f1e6', // 🇸🇦 flag: Saudi Arabia
  '1f1f8-1f1e7', // 🇸🇧 flag: Solomon Islands
  '1f1f8-1f1e8', // 🇸🇨 flag: Seychelles
  '1f1f8-1f1e9', // 🇸🇩 flag: Sudan
  '1f1f8-1f1ea', // 🇸🇪 flag: Sweden
  '1f1f8-1f1ec', // 🇸🇬 flag: Singapore
  '1f1f8-1f1ed', // 🇸🇭 flag: St. Helena
  '1f1f8-1f1ee', // 🇸🇮 flag: Slovenia
  '1f1f8-1f1ef', // 🇸🇯 flag: Svalbard & Jan Mayen
  '1f1f8-1f1f0', // 🇸🇰 flag: Slovakia
  '1f1f8-1f1f1', // 🇸🇱 flag: Sierra Leone
  '1f1f8-1f1f2', // 🇸🇲 flag: San Marino
  '1f1f8-1f1f3', // 🇸🇳 flag: Senegal
  '1f1f8-1f1f4', // 🇸🇴 flag: Somalia
  '1f1f8-1f1f7', // 🇸🇷 flag: Suriname
  '1f1f8-1f1f8', // 🇸🇸 flag: South Sudan
  '1f1f8-1f1f9', // 🇸🇹 flag: São Tomé & Príncipe
  '1f1f8-1f1fb', // 🇸🇻 flag: El Salvador
  '1f1f8-1f1fd', // 🇸🇽 flag: Sint Maarten
  '1f1f8-1f1fe', // 🇸🇾 flag: Syria
  '1f1f8-1f1ff', // 🇸🇿 flag: Eswatini
  '1f1f9-1f1e6', // 🇹🇦 flag: Tristan da Cunha
  '1f1f9-1f1e8', // 🇹🇨 flag: Turks & Caicos Islands
  '1f1f9-1f1e9', // 🇹🇩 flag: Chad
  '1f1f9-1f1eb', // 🇹🇫 flag: French Southern Territories
  '1f1f9-1f1ec', // 🇹🇬 flag: Togo
  '1f1f9-1f1ed', // 🇹🇭 flag: Thailand
  '1f1f9-1f1ef', // 🇹🇯 flag: Tajikistan
  '1f1f9-1f1f0', // 🇹🇰 flag: Tokelau
  '1f1f9-1f1f1', // 🇹🇱 flag: Timor-Leste
  '1f1f9-1f1f2', // 🇹🇲 flag: Turkmenistan
  '1f1f9-1f1f3', // 🇹🇳 flag: Tunisia
  '1f1f9-1f1f4', // 🇹🇴 flag: Tonga
  '1f1f9-1f1f7', // 🇹🇷 flag: Türkiye
  '1f1f9-1f1f9', // 🇹🇹 flag: Trinidad & Tobago
  '1f1f9-1f1fb', // 🇹🇻 flag: Tuvalu
  '1f1f9-1f1fc', // 🇹🇼 flag: Taiwan
  '1f1f9-1f1ff', // 🇹🇿 flag: Tanzania
  '1f1fa-1f1e6', // 🇺🇦 flag: Ukraine
  '1f1fa-1f1ec', // 🇺🇬 flag: Uganda
  '1f1fa-1f1f2', // 🇺🇲 flag: U.S. Outlying Islands
  '1f1fa-1f1f8', // 🇺🇸 flag: United States
  '1f1fa-1f1fe', // 🇺🇾 flag: Uruguay
  '1f1fa-1f1ff', // 🇺🇿 flag: Uzbekistan
  '1f1fb-1f1e6', // 🇻🇦 flag: Vatican City
  '1f1fb-1f1e8', // 🇻🇨 flag: St. Vincent & Grenadines
  '1f1fb-1f1ea', // 🇻🇪 flag: Venezuela
  '1f1fb-1f1ec', // 🇻🇬 flag: British Virgin Islands
  '1f1fb-1f1ee', // 🇻🇮 flag: U.S. Virgin Islands
  '1f1fb-1f1f3', // 🇻🇳 flag: Vietnam
  '1f1fb-1f1fa', // 🇻🇺 flag: Vanuatu
  '1f1fc-1f1eb', // 🇼🇫 flag: Wallis & Futuna
  '1f1fc-1f1f8', // 🇼🇸 flag: Samoa
  '1f1fd-1f1f0', // 🇽🇰 flag: Kosovo
  '1f1fe-1f1ea', // 🇾🇪 flag: Yemen
  '1f1fe-1f1f9', // 🇾🇹 flag: Mayotte
  '1f1ff-1f1e6', // 🇿🇦 flag: South Africa
  '1f1ff-1f1f2', // 🇿🇲 flag: Zambia
  '1f1ff-1f1fc', // 🇿🇼 flag: Zimbabwe
];

export default emojiMap;
